/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Why the request collided with the current state, for the interface to say in its own words; detail says the same in English for a developer. KEY_TAKEN — the question key is used, letter case aside. NAME_TAKEN — the name of a test, survey, category or tag is taken. PREFIX_TAKEN — another category has the prefix. PREFIX_IN_USE — keys have been built from the prefix, so it stays. VERSION_STATUS — the version\'s status does not allow it, e.g. correcting a retired version. MATERIAL_IN_FORCE — an answer carrying material was left out of a correction of the version in force, which keeps its material; send the answer\'s id or create a new version. IN_USE — something depends on it, so it cannot be deleted. NEVER_IN_USE — a draft is deleted, not retired. ANONYMITY_FIXED — answers were given under the survey\'s anonymity setting. CONFIRMATION_REQUIRED — a large bulk change needs confirmLargeChange. NOT_READY — gaps keep the test or survey from going live. CLASH — the database refused the write, most likely because the same thing was just saved by somebody else. Attempts add TEST_NOT_ACTIVE — only an active test is taken; ATTEMPT_LIMIT_REACHED — the person has used every attempt the test allows; EXAMINER_REQUIRED — a practical exam, which an examiner runs rather than a screen; ATTEMPT_OVER — the attempt is finished or its time ran out; GOING_BACK_NOT_ALLOWED — the test takes its questions in order, each answer final; UNANSWERED — finishing needs every question answered; ALREADY_PASSED — the person has passed the test, which takes no attempt after a pass; ATTEMPT_IN_PROGRESS — an attempt closes once it is over; PERSON_LOCKED — the person\'s attempts at the test are locked, or already were when locking; ALREADY_INVALIDATED — the attempt was invalidated before. Survey responses add SURVEY_NOT_ACTIVE — only an active survey is filled in; RESPONSE_OVER — the response is submitted or refused; MISSING_REQUIRED — submitting needs every required question answered. Exams add NOT_AN_EXAM — only a practical exam is run by an examiner; UNGRADED — finishing needs every question marked, with the comments its questions require. Values may be added; an unknown one is a conflict without a reason.
 * @export
 * @enum {string}
 */

export const ConflictReasonDto = {
    KeyTaken: 'KEY_TAKEN',
    NameTaken: 'NAME_TAKEN',
    PrefixTaken: 'PREFIX_TAKEN',
    PrefixInUse: 'PREFIX_IN_USE',
    VersionStatus: 'VERSION_STATUS',
    MaterialInForce: 'MATERIAL_IN_FORCE',
    InUse: 'IN_USE',
    NeverInUse: 'NEVER_IN_USE',
    AnonymityFixed: 'ANONYMITY_FIXED',
    ConfirmationRequired: 'CONFIRMATION_REQUIRED',
    NotReady: 'NOT_READY',
    Clash: 'CLASH',
    TestNotActive: 'TEST_NOT_ACTIVE',
    AttemptLimitReached: 'ATTEMPT_LIMIT_REACHED',
    ExaminerRequired: 'EXAMINER_REQUIRED',
    AttemptOver: 'ATTEMPT_OVER',
    GoingBackNotAllowed: 'GOING_BACK_NOT_ALLOWED',
    Unanswered: 'UNANSWERED',
    AlreadyPassed: 'ALREADY_PASSED',
    AttemptInProgress: 'ATTEMPT_IN_PROGRESS',
    PersonLocked: 'PERSON_LOCKED',
    AlreadyInvalidated: 'ALREADY_INVALIDATED',
    SurveyNotActive: 'SURVEY_NOT_ACTIVE',
    ResponseOver: 'RESPONSE_OVER',
    MissingRequired: 'MISSING_REQUIRED',
    NotAnExam: 'NOT_AN_EXAM',
    Ungraded: 'UNGRADED'
} as const;

export type ConflictReasonDto = typeof ConflictReasonDto[keyof typeof ConflictReasonDto];



